const account_center = {
    not_enabled: 'Centro account non è abilitato.',
    field_not_editable: 'Il campo non è modificabile.',
    field_not_enabled: 'Il campo non è abilitato.',
};
export default Object.freeze(account_center);
